import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { environment } from '@env/environment';

const routes: Routes = [
  {
    path: '',
    children: [
      { path: 'distributor', loadChildren: () => import('src/app/distributor/distributor.module').then(m => m.DistributorModule) },
      { path: 'corporation', loadChildren: () => import('src/app/corporation/corporation.module').then(m => m.CorporationModule) },
      { path: 'pharmacy', loadChildren: () => import('src/app/pharmacy/pharmacy.module').then(m => m.PharmacyModule) },
      { path: 'admin', loadChildren: () => import('src/app/admin/admin.module').then(m => m.AdminModule) },
      { path: '**', redirectTo: 'pharmacy/passport/login', pathMatch: 'full' }
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: environment.useHash,
      // NOTICE: If you use `reuse-tab` component and turn on keepingScroll you can set to `disabled`
      // Pls refer to https://ng-alain.com/components/reuse-tab
      scrollPositionRestoration: 'top'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
